import * as d3 from 'd3-selection'
import fontSize from './font-size.js'

const height = 8
    , totalFields = 3
    // we want slightly smaller padding than the global padding
    , paddingOverridePercent = 0.5
    , padding = {
       top: 1.5,
       bottom: 2
    }

export default function (dimensions) {
  var fieldWidth = (dimensions.viewbox.width - (dimensions.padding.left + dimensions.padding.right) * paddingOverridePercent) / totalFields
    , translateX = (dimensions.padding.left * paddingOverridePercent) + (fieldWidth / 2)

  function draw (selection) {
    selection.each(function (data) {
      var fields = d3.select(this)
                     .selectAll('g.fields')
                     .data(data.fields ? [data.fields] : [])
        , field = fields.enter()
                        .append('g')
                          .attr('class', 'fields')
                          .merge(fields)
                            .attr('transform', 'translate(' + translateX + ',' + (dimensions.viewbox.height + padding.top) + ')')
                            .selectAll('g.field')
                            .data(function (d) {
                              return d
                            })
        , enter = field.enter()
                       .append('g')
                         .attr('class', 'field')
        , _field = enter.merge(field)

      fields.exit().remove()
      field.exit().remove()

      enter.append('text')
             .attr('class', 'value')
      enter.append('text')
             .attr('class', 'label')

      _field.attr('transform', function (d, i) {
              return 'translate(' + (_field.size() === 1 ? fieldWidth : (i * fieldWidth)) + ', 0)'
            })

      _field.select('.value').text(function (d) {
              return d.formatted
            })
            .style('font-size', function (d) {
              return fontSize(this, d.formatted, 'value', (dimensions.viewbox.width / 3), 9)
            })

      _field.select('.label').text(function (d) {
              return d.label
            })
            .attr('y', height)

      if (_field.selectAll('*').size()) {
        dimensions.viewbox.height += (height * 2) + padding.top + padding.bottom
      }
    })
  }

  return draw
}
